<pg-header
  title="Sachivalayams"
  ticon="folder"
  bckbtn="true"
  bckurl="/setup"
></pg-header>
@if (usrAcsErrMsg == false) {
<div>
  @if ((USER_PERMISSIONS.slct_in==1)?true:false) {
  <div nz-row class="gridTop">
    @if (loader) {
    <ds-loading></ds-loading>
    }
    <div class="ds-card grid">
      <app-data-grid
        id="gridContainer"
        style="width: 100%"
        [dataSource]="gridData"
        [legacyColumns]="columnDefs"
        [searchPanel]="true"
        [filterRow]="true"
        [filterPanel]="true"
        [groupPanel]="true"
        [columnChooser]="true"
        [allowExport]="USER_PERMISSIONS.exprt_in == 1 ? true : false"
        exportFileName="Designations List"
        [pageSize]="10"
        [allowedPageSizes]="[10, 25, 50, 100]"
        [showPageSizeSelector]="true"
        [rowAlternationEnabled]="true"
        [showBorders]="true"
      >
        <app-grid-column
          [showInColumnChooser]="false"
          type="buttons"
          [visible]="USER_PERMISSIONS.dlte_in == 1 ? true : false"
          [width]="100"
          caption="Edit"
          cellTemplate="editTemplate"
        ></app-grid-column>
        <ng-template appGridCell="editTemplate" let-data="cell"
          ><div>
            <div class="tblEdtBtn" (click)="onEdit2(data)">Edit</div>
          </div></ng-template
        >
        <app-grid-column
          [showInColumnChooser]="false"
          [visible]="USER_PERMISSIONS.dlte_in == 1 ? true : false"
          type="buttons"
          [width]="100"
          caption="Delete"
          cellTemplate="delTemplate"
        ></app-grid-column>
        <ng-template appGridCell="delTemplate" let-data="cell"
          ><div>
            <div class="tblDelBtn" (click)="onDelete2(data)">Delete</div>
          </div></ng-template
        >
      </app-data-grid>
    </div>
    @if ((USER_PERMISSIONS.slct_in==1)?false:true) {
    <div class="permMsg">{{ mainMessage }}</div>
    }
  </div>
  }
  <!-- </div>
</div>
</div> -->
  <nz-drawer
    [nzBodyStyle]="{
      height: 'calc(100% - 55px)',
      overflow: 'auto',
      'padding-bottom': '53px'
    }"
    [nzMaskClosable]="false"
    [nzWidth]="370"
    [nzVisible]="shwSidebar"
    [nzTitle]="sidebarHeading"
    (nzOnClose)="closeSideBar()"
  >
    <form nz-form [formGroup]="sachivalayamForm">
      <div class="input-row mt-2" nz-row>
        <div
          nz-col
          nzXs="24"
          nzSm="24"
          nzMd="24"
          nzLg="24"
          nzXl="24"
          class="schvlmMrgn"
        >
          <div class="inptLbl">Sachivalayam Name</div>
          <input type="text" nz-input formControlName="svm_nm" />
        </div>
        <div
          nz-col
          nzXs="24"
          nzSm="24"
          nzMd="24"
          nzLg="24"
          nzXl="24"
          class="schvlmMrgn"
        >
          <div class="inptLbl">Sachivalayam Code</div>
          <input type="number" nz-input formControlName="svm_cd" />
        </div>
      </div>
      <div class="input-row mt-2" nz-row>
        <div
          nz-col
          nzXs="24"
          nzSm="24"
          nzMd="24"
          nzLg="24"
          nzXl="24"
          class="schvlmMrgn"
        >
          <div class="inptLbl">Sachivalayam Short Name</div>
          <input type="text" nz-input formControlName="svm_shrt_nm" />
        </div>
        <div
          nz-col
          nzXs="24"
          nzSm="24"
          nzMd="24"
          nzLg="24"
          nzXl="24"
          class="schvlmMrgn"
        >
          <div class="inptLbl">District</div>
          <nz-select
            class="slctwidth"
            style="width: 100%"
            nzPlaceHolder="Select Districts"
            formControlName="dstrct_id"
            (ngModelChange)="getulbs($event)"
          >
            @for (d of dstrctsLst; track d) {
            <nz-option [nzValue]="d.dstrt_id" [nzLabel]="d.dstrt_nm">
            </nz-option>
            }
          </nz-select>
        </div>
      </div>
      <div class="input-row mt-2" nz-row>
        <div
          nz-col
          nzXs="24"
          nzSm="24"
          nzMd="24"
          nzLg="24"
          nzXl="24"
          class="schvlmMrgn"
        >
          <div class="inptLbl">Urban/Rural</div>
          <nz-select
            class="slctwidth"
            style="width: 100%"
            nzPlaceHolder="Select"
            formControlName="urbn_in"
          >
            @for (a of area; track a) {
            <nz-option [nzLabel]="a.area_nm" [nzValue]="a.id"></nz-option>
            }
          </nz-select>
        </div>
        <div
          nz-col
          nzXs="24"
          nzSm="24"
          nzMd="24"
          nzLg="24"
          nzXl="24"
          class="schvlmMrgn"
        >
          <div class="inptLbl">ULB</div>
          <nz-select
            class="slctwidth"
            style="width: 100%"
            nzPlaceHolder="Select ULB's"
            formControlName="ulb_id"
          >
            @for (u of ulbLst; track u) {
            <nz-option [nzValue]="u.ulb_id" [nzLabel]="u.ulb_nm"></nz-option>
            }
          </nz-select>
        </div>
      </div>
      @if (shwschvlymEditDiv==false && shwschvlymDelDiv==false) {
      <button
        nz-button
        nzType="primary"
        class="sbmtBtm"
        (click)="savesachivalayam()"
      >
        Submit
      </button>
      } @if (shwschvlymEditDiv==true && shwschvlymDelDiv==false) {
      <button
        nz-button
        nzType="primary"
        class="sbmtBtm"
        (click)="saveEditsachivalayam()"
      >
        Update
      </button>
      } @if (shwschvlymEditDiv==false && shwschvlymDelDiv==true) {
      <button
        nz-button
        nzType="primary"
        class="sbmtBtm"
        (click)="saveDeletesachivalayam()"
      >
        Delete
      </button>
      }
      <button nz-button nzType="default" class="cnclBtn" (click)="cancel()">
        Cancel
      </button>
    </form>
  </nz-drawer>
</div>
} @if (usrAcsErrMsg == true) {
<div class="permMsg">
  <nz-result
    nzStatus="error"
    nzTitle="Access Denied"
    nzSubTitle="You do not have permissions to do this operation. Please contact Administrator to get permissions."
  >
    <!-- <div nz-result-extra>
      <button nz-button nzType="primary" (click)="bckToHm()">Back to home</button>
    </div> -->
  </nz-result>
</div>
}
